import { cloneDeep } from '@apollo/client/utilities';
import { forCreate, forDelete, forUpdate } from '../common/entity';
import { EntityInput } from '../common/entity';
import { CustomField, CustomFieldEntityType } from '../custom_field/customField';
import { Bin } from './bin';

export class BinInput extends Bin implements EntityInput<Bin> {
  forCreate(): CreateBinInput {
    return CreateBinInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      CreateBinInput,
    );
  }

  forUpdate(): UpdateBinInput {
    return UpdateBinInput.from(
      {
        ...this,
        customFields: this.customFieldValues(),
      },
      UpdateBinInput,
    );
  }

  forDelete(): DeleteBinInput {
    return DeleteBinInput.from(this, DeleteBinInput);
  }

  // TODO: Custom fields
  validate(customFields: Map<string, CustomField>) {
    const mandatoryCustomFields = [...customFields.values()].filter(
      cf => cf.entityType === CustomFieldEntityType.bin && cf.mandatory,
    );

    if (!this.name || !this.binStatusId) return false;
    if (mandatoryCustomFields.some(cf => !this.customFields.get(cf.id)?.value)) return false;

    return true;
  }

  hasChanges(original?: Bin) {
    if (!original) return true;

    if (this.name !== original.name) return true;
    if (this.binStatusId !== original.binStatusId) return true;
    if (this.customFields.size !== original.customFields.size) return true;
    if (
      [...this.customFields.entries()].some(([key, value]) => original.customFields.get(key)?.value !== value.value)
    ) {
      return true;
    }
    if (
      [...original.customFields.entries()].some(([key, value]) => this.customFields.get(key)?.value !== value.value)
    ) {
      return true;
    }

    return false;
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withBinStatusId(binStatusId?: string) {
    this.binStatusId = binStatusId || '';
    return cloneDeep(this);
  }
}

export class CreateBinInput extends forCreate(Bin) {}

export class UpdateBinInput extends forUpdate(Bin) {}

export class DeleteBinInput extends forDelete(Bin) {}
